const roles = {
  booker: 'Booker',
  billPayer: 'Bill Payer',
  primaryUser: 'Primary User',
} as const;

export type Role = (typeof roles)[keyof typeof roles];

export default roles;
